<template>
    <div>
        <div class="about">
            <div class="about-content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h1>About Us</h1>
                            <hr />
                            <p>We are a team specialized on <strong>High Quality Software Development, Systems Architecture and UI/UX Design</strong> that can help build the perfect solutions for your business as well as advise what is the best way to go.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h1 class="page-title">Services</h1>
                            <h3 class="page-description">We offer our customers a wide range of solutions to help them grow and suceed in their business.</h3>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="row services-row">
                        <div class="col-md-4">
                            <img src="/public/img/services/software.png" class="img-responsive">
                            <h4 class="text-center">Custom Software Development</h4>
                            <p>We offer Software development services for web, mobile and desktop.</p>
                            <p>We deliver top quality apps cappable of full integration with other systems, technologies or legacy software.</p>
                        </div>
                        <div class="col-md-4">
                            <img src="/public/img/services/web.png" class="img-responsive">
                            <h4 class="text-center">Websites and Portals</h4>
                            <p>We develop Websites and Portals using the best and latest technologies such as HTML 5, CSS3, JavaScript.</p>
                            <p>Our team delivers beautiful, fast and responsive websites that work, and look great, across every platform.</p>
                        </div>
                        <div class="col-md-4">
                            <img src="/public/img/services/mobile.png" class="img-responsive">
                            <h4 class="text-center">Mobile Apps</h4>
                            <p>We develop iOS, Android, WP or Hybrid apps.</p>
                            <p>We can also develop the mobile back-ends or provide integration with already exisiting services or systems.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Home',
        data () {
            return {
                msg: 'Welcome to ABOUT US App'
            }
        }
    }
</script>

<style>
.about-content{
    min-height: 700px;
    color:#000;
}

.about-second{
    min-height: 600px;
}

</style>
